///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.atp_documents = abcsetup.atp_documents || {};
abcsetup.atp_documents.upload = abcsetup.atp_documents.upload || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.atp_documents.upload = {

}